// @flow
import React, { Component } from 'react';
import { withAuth } from 'components/provider/Auth';
import { withRouter, Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

class OnlyUnauthRoute extends Component {
  render() {
    const { component: TheComponent, token, render, ...rest } = this.props;
    return (
      <Route
        {...rest}
        render={props => {
          if (!token) {
            return render ? render(props) : <TheComponent {...props} />;
          } else {
            return (
              <Redirect
                to={{
                  pathname: '/'
                }}
              />
            );
          }
        }}
      />
    );
  }
}

OnlyUnauthRoute.contextTypes = {
  component: PropTypes.object
};

export default withRouter(
  withAuth(
    connect()(OnlyUnauthRoute)
  )
);
